"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const rename_1 = require("../../../app/dist/rename");
exports.toolDef = {
    name: 'loom_retitle',
    description: "Retitle a document: updates its title (and synced body H1) only. The permanent id and the filename are unchanged — identity is not derived from the title, so backlinks stay intact. (Renamed from loom_rename — it only ever changed the title.) Use this tool to retitle Loom docs — do not edit files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            doc_ulid: { type: 'string', description: "The document's ULID" },
            newTitle: { type: 'string', description: 'New human-readable title (the id is NOT changed)' },
        },
        required: ['doc_ulid', 'newTitle'],
    },
};
async function handle(root, args) {
    // Resolve the agent-supplied doc_ulid at the delivery boundary: gives suggest-on-miss
    // (a stem/typo is rejected with the canonical id) so findDocumentById locates the doc.
    const { id: resolvedOldId } = await (0, dist_1.resolveDocIdOrThrow)(root, args['doc_ulid']);
    const result = await (0, rename_1.rename)({ oldId: resolvedOldId, newTitle: args['newTitle'] }, {
        loadDoc: dist_1.loadDoc,
        saveDoc: dist_1.saveDoc,
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        findDocumentById: dist_1.findDocumentById,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
